// extracted by mini-css-extract-plugin
export default {"textButton":"m7Ce9q","disabled":"ccH9ff","disableClick":"AfNKcy","text":"SNb21Q","underline":"DsJGRc","underlineOnHover":"zGgxVK","standard":"Z38N1m","shadow":"bC44uk"};